// src/components/Forms/Input.jsx
import { useController } from 'react-hook-form';

const Input = ({ name, control, label, type = 'text', placeholder, rules, disabled = false, ...props }) => {
  const {
    field,
    fieldState: { error },
  } = useController({ name, control, rules });

  return (
    <div className="form-group">
      {label && <label htmlFor={name}>{label}</label>}
      <input
        id={name}
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        {...field}
        {...props}
        className={error ? 'input-error' : ''}
      />
      {error && <span className="error-message">{error.message}</span>}
    </div>
  );
};

export default Input;